import React, { useEffect, useState } from 'react';

const BackgroundEffects = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Criar 30 partículas com posições aleatórias
    const newParticles = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: Math.random() * 3 + 2, // 2-5px
      duration: Math.random() * 10 + 15, // 15-25s
      delay: Math.random() * 5,
      opacity: Math.random() * 0.4 + 0.3, // 0.3-0.7
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {/* Partículas animadas */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute bg-red-600 rounded-full animate-float"
          style={{
            left: `${particle.left}%`,
            top: `${particle.top}%`,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            opacity: particle.opacity,
            animationDuration: `${particle.duration}s`,
            animationDelay: `${particle.delay}s`,
          }}
        ></div>
      ))}
      
      {/* Orbs com brilho maior e mais visíveis */}
      <div className="absolute top-20 right-1/4 w-64 h-64 bg-red-600/10 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute bottom-40 left-1/4 w-80 h-80 bg-red-600/10 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-red-600/5 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '4s' }}></div>
      
      {/* Linhas de energia sutis */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute h-px w-full bg-gradient-to-r from-transparent via-red-600 to-transparent top-1/4 animate-scan"></div>
        <div className="absolute h-px w-full bg-gradient-to-r from-transparent via-red-600 to-transparent top-2/3 animate-scan" style={{ animationDelay: '3s' }}></div>
      </div>
    </div>
  );
};

export default BackgroundEffects;
